// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"30":"5ca515e0","253":"bc1efbe8","286":"1d35b769","661":"c80bb955"}[chunkId] + ".chunk.css";
};